module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (158).10c15ec7.jpg";